<div class="icon-click-root"
  [ngClass]="{'small': small}">
  <mat-icon><ng-content></ng-content></mat-icon>
</div>
